import{a as it,c as $,d as G,e as D,f as St,g as et,h as F,i as x,j as rt,k as st,l as nt,m as j,n as q}from"./ids-chunk-FWKPQHTC.js";import{a as Rt}from"./ids-chunk-P22N4AWR.js";import{a as It}from"./ids-chunk-PR3XQCA5.js";import{a as xt}from"./ids-chunk-VEO6QETS.js";import{a as Tt}from"./ids-chunk-U4K5B3VN.js";import{c as ot}from"./ids-chunk-ZUHWNQKP.js";import{a as vt,b as yt}from"./ids-chunk-XE4WFW5M.js";import{a as kt}from"./ids-chunk-W3LDHTW6.js";import{c as Q,d as W,j as Z,l as At,r as tt}from"./ids-chunk-BVOD446S.js";import{a as Et,e as B}from"./ids-chunk-Y6KVKFJX.js";import{a as d}from"./ids-chunk-TFRXZ5TN.js";import{a as wt,b as V,c as s,d as g,e as l,f as p}from"./ids-chunk-ZMMCFAAI.js";var Pt=`/* Ids Popup Component */
/** Generates a Module Nav IdsPopup style */
:host {
  display: block;
  z-index: var(--ids-z-index-60);
  text-align: unset;
}

:host([type=tooltip]) {
  z-index: var(--ids-z-index-tooltips);
}

:host([position-style=absolute]) {
  position: absolute;
}

:host([position-style=fixed]) {
  position: fixed;
}

:host([position-style=viewport]) {
  position: static;
}

:host(:not([visible])) {
  pointer-events: none;
  display: none;
}

:host([visible]) {
  display: block;
}

:host([visible][animated]) {
  transition: left var(--ids-motion-duration) var(--ids-motion-linear), top var(--ids-motion-duration) var(--ids-motion-linear);
}

.ids-popup {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}
.ids-popup:not(.open) {
  pointer-events: none;
}
.ids-popup .arrow {
  border-width: var(--ids-popup-arrow-size);
  display: none;
  position: absolute;
}
.ids-popup .arrow.bottom, .ids-popup .arrow.left, .ids-popup .arrow.right, .ids-popup .arrow.top {
  border-style: solid;
  border-color: var(--ids-color-transparent);
  display: block;
  height: 0;
  width: 0;
}
.ids-popup .arrow::after {
  border-style: solid;
  border-color: var(--ids-color-transparent);
  border-width: var(--ids-popup-arrow-size);
  content: "";
  display: block;
  position: relative;
}
.ids-popup .arrow.bottom {
  border-top-width: var(--ids-border-width-none);
  left: calc(50% - var(--ids-popup-arrow-size));
  top: calc(var(--ids-popup-arrow-size) * -1);
}
.ids-popup .arrow.bottom::after {
  border-top-width: var(--ids-border-width-none);
  left: calc(var(--ids-popup-arrow-size) * -1);
  top: 1px;
}
.ids-popup .arrow.left {
  border-right-width: var(--ids-border-width-none);
  right: calc(var(--ids-popup-arrow-size) * -1);
  top: calc(50% - var(--ids-popup-arrow-size));
}
.ids-popup .arrow.left::after {
  border-right-width: var(--ids-border-width-none);
  left: calc(var(--ids-popup-arrow-size) * -1);
  top: calc(var(--ids-popup-arrow-size) * -1);
}
.ids-popup .arrow.right {
  border-left-width: var(--ids-border-width-none);
  left: calc(var(--ids-popup-arrow-size) * -1);
  top: calc(50% - var(--ids-popup-arrow-size));
}
.ids-popup .arrow.right::after {
  border-left-width: var(--ids-border-width-none);
  left: 1px;
  top: calc(var(--ids-popup-arrow-size) * -1);
}
.ids-popup .arrow.top {
  border-bottom-width: var(--ids-border-width-none);
  bottom: calc(var(--ids-popup-arrow-size) * -1);
  left: calc(50% - var(--ids-popup-arrow-size));
}
.ids-popup .arrow.top::after {
  border-bottom-width: var(--ids-border-width-none);
  left: calc(var(--ids-popup-arrow-size) * -1);
  top: calc(var(--ids-popup-arrow-size) * -1 - 1px);
}
.ids-popup.animated {
  transition: border-color var(--ids-motion-duration) var(--ids-motion-linear), opacity var(--ids-motion-duration) var(--ids-motion-linear), transform var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-popup.animated ::slotted(*) {
  transition: opacity var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-popup.animated.open {
  transition: border-color var(--ids-motion-duration) var(--ids-motion-linear), opacity var(--ids-motion-duration) var(--ids-motion-linear), height var(--ids-motion-duration) var(--ids-motion-linear), width var(--ids-motion-duration) var(--ids-motion-linear), transform var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-popup.animation-fade {
  opacity: 0;
}
.ids-popup.animation-fade.open {
  opacity: 1;
}
.ids-popup.animation-scale-in {
  opacity: 0;
  transform-style: preserve-3d;
  transform: perspective(1000px) translate3d(0, 0, -500px);
}
.ids-popup.animation-scale-in ::slotted(*) {
  opacity: 0;
}
.ids-popup.animation-scale-in.open {
  opacity: 1;
  transform: perspective(1000px) translate3d(0, 0, 0);
}
.ids-popup.animation-scale-in.open ::slotted(*) {
  opacity: 1;
}
.ids-popup.animation-slide-from-bottom {
  opacity: 0;
  transform-style: preserve-3d;
  transform: perspective(1000px) translate3d(100%, 0, 0);
}
.ids-popup.animation-slide-from-bottom.open {
  opacity: 1;
  transform: perspective(1000px) translate3d(0, 0, 0);
}
.ids-popup.position-viewport {
  position: absolute;
  left: 50%;
  top: 50%;
  transform-origin: left top;
  transform: translate(-50%, -50%);
  min-height: 15%;
  min-width: 15%;
  max-height: 100%;
  max-width: 100%;
}
.ids-popup.position-viewport.fit-viewport {
  height: var(--ids-popup-fit-height);
}
.ids-popup.position-viewport.animation-scale-in {
  transform: perspective(1000px) translate3d(-50%, -50%, -500px);
}
.ids-popup.position-viewport.animation-scale-in.open {
  transform: perspective(1000px) translate3d(-50%, -50%, 0);
}
.ids-popup.position-viewport.animation-slide-from-bottom {
  transform: perspective(1000px) translate3d(-50%, 110%, -100px);
}
.ids-popup.position-viewport.animation-slide-from-bottom.open {
  transform: perspective(1000px) translate3d(-50%, -50%, 0);
}
.ids-popup.none {
  background-color: var(--ids-popup-color-background);
  border: 1px solid var(--ids-popup-color-border);
  padding: 1px solid var(--ids-popup-padding);
}
.ids-popup.custom {
  background-color: var(--ids-popup-color-background);
  border: 1px solid transparent;
}
.ids-popup.menu {
  background-color: var(--ids-popup-menu-color-background-default);
  border: 1px solid var(--ids-popup-menu-color-border-default);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  padding-block: var(--ids-popup-menu-padding);
  color: var(--ids-popup-menu-color-text-default);
  border-radius: var(--ids-popup-menu-border-radius);
  box-shadow: var(--ids-popup-menu-shadow-default);
}
.ids-popup.menu .arrow.bottom {
  border-bottom-color: var(--ids-popup-menu-color-border-default);
}
.ids-popup.menu .arrow.bottom::after {
  border-bottom-color: var(--ids-popup-menu-color-background-default);
}
.ids-popup.menu .arrow.left {
  border-left-color: var(--ids-popup-menu-color-border-default);
}
.ids-popup.menu .arrow.left::after {
  border-left-color: var(--ids-popup-menu-color-background-default);
}
.ids-popup.menu .arrow.right {
  border-right-color: var(--ids-popup-menu-color-border-default);
}
.ids-popup.menu .arrow.right::after {
  border-right-color: var(--ids-popup-menu-color-background-default);
}
.ids-popup.menu .arrow.top {
  border-top-color: var(--ids-popup-menu-color-border-default);
}
.ids-popup.menu .arrow.top::after {
  border-top-color: var(--ids-popup-menu-color-background-default);
}
.ids-popup.menu-alt {
  background-color: var(--ids-popup-menu-color-background-inverse);
  border: 1px solid var(--ids-popup-menu-color-border-inverse);
  padding-block: var(--ids-popup-menu-padding);
  box-shadow: var(--ids-popup-menu-shadow-inverse);
  font-size: var(--ids-popup-menu-font-size);
  color: var(--ids-popup-menu-color-text-inverse);
  border-color: var(--ids-popup-menu-color-border-inverse);
  border-radius: var(--ids-border-radius-2xs);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
}
.ids-popup.menu-alt .arrow.bottom,
.ids-popup.menu-alt .arrow.bottom::after {
  border-bottom-color: var(--ids-popup-menu-color-border-inverse);
}
.ids-popup.menu-alt .arrow.left,
.ids-popup.menu-alt .arrow.left::after {
  border-left-color: var(--ids-popup-menu-color-border-inverse);
}
.ids-popup.menu-alt .arrow.right,
.ids-popup.menu-alt .arrow.right::after {
  border-right-color: var(--ids-popup-menu-color-border-inverse);
}
.ids-popup.menu-alt .arrow.top,
.ids-popup.menu-alt .arrow.top::after {
  border-top-color: var(--ids-popup-menu-color-border-inverse);
}
.ids-popup.tooltip {
  background-color: var(--ids-tooltip-color-background);
  border-radius: var(--ids-tooltip-border-radius);
  box-shadow: var(--ids-tooltip-shadow);
  cursor: var(--ids-cursor-pointer);
  color: var(--ids-tooltip-color-text);
  display: inline-block;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-tooltip-font-size);
  max-width: 75vw;
  padding: var(--ids-tooltip-padding);
  width: auto;
  word-wrap: break-word;
  z-index: var(--ids-z-index-70);
}
.ids-popup.tooltip .arrow.bottom,
.ids-popup.tooltip .arrow.bottom::after {
  border-bottom-color: var(--ids-tooltip-color-background);
}
.ids-popup.tooltip .arrow.bottom {
  top: -6px;
}
.ids-popup.tooltip .arrow.left,
.ids-popup.tooltip .arrow.left::after {
  border-left-color: var(--ids-tooltip-color-background);
}
.ids-popup.tooltip .arrow.left {
  right: -6px;
}
.ids-popup.tooltip .arrow.right,
.ids-popup.tooltip .arrow.right::after {
  border-right-color: var(--ids-tooltip-color-background);
}
.ids-popup.tooltip .arrow.right {
  left: -6px;
}
.ids-popup.tooltip .arrow.top,
.ids-popup.tooltip .arrow.top::after {
  border-top-color: var(--ids-tooltip-color-background);
}
.ids-popup.tooltip .arrow.top {
  bottom: -6px;
}
.ids-popup.tooltip.error-color {
  background-color: var(--ids-tooltip-error-color-background-error);
}
.ids-popup.tooltip.error-color .arrow.bottom,
.ids-popup.tooltip.error-color .arrow.bottom::after {
  border-bottom-color: var(--ids-tooltip-error-color-background-error);
}
.ids-popup.tooltip.error-color .arrow.left,
.ids-popup.tooltip.error-color .arrow.left::after {
  border-left-color: var(--ids-tooltip-error-color-background-error);
}
.ids-popup.tooltip.error-color .arrow.right,
.ids-popup.tooltip.error-color .arrow.right::after {
  border-right-color: var(--ids-tooltip-error-color-background-error);
}
.ids-popup.tooltip.error-color .arrow.top,
.ids-popup.tooltip.error-color .arrow.top::after {
  border-top-color: var(--ids-tooltip-error-color-background-error);
}
.ids-popup.tooltip.info-color {
  background-color: var(--ids-tooltip-info-color-background-info);
}
.ids-popup.tooltip.info-color .arrow.bottom,
.ids-popup.tooltip.info-color .arrow.bottom::after {
  border-bottom-color: var(--ids-tooltip-info-color-background-info);
}
.ids-popup.tooltip.info-color .arrow.left,
.ids-popup.tooltip.info-color .arrow.left::after {
  border-left-color: var(--ids-tooltip-info-color-background-info);
}
.ids-popup.tooltip.info-color .arrow.right,
.ids-popup.tooltip.info-color .arrow.right::after {
  border-right-color: var(--ids-tooltip-info-color-background-info);
}
.ids-popup.tooltip.info-color .arrow.top,
.ids-popup.tooltip.info-color .arrow.top::after {
  border-top-color: var(--ids-tooltip-info-color-background-info);
}
.ids-popup.tooltip.alert-color, .ids-popup.tooltip.warning-color {
  background-color: var(--ids-tooltip-color-background-warning);
}
.ids-popup.tooltip.alert-color .arrow.bottom,
.ids-popup.tooltip.alert-color .arrow.bottom::after, .ids-popup.tooltip.warning-color .arrow.bottom,
.ids-popup.tooltip.warning-color .arrow.bottom::after {
  border-bottom-color: var(--ids-tooltip-color-background-warning);
}
.ids-popup.tooltip.alert-color .arrow.left,
.ids-popup.tooltip.alert-color .arrow.left::after, .ids-popup.tooltip.warning-color .arrow.left,
.ids-popup.tooltip.warning-color .arrow.left::after {
  border-left-color: var(--ids-tooltip-color-background-warning);
}
.ids-popup.tooltip.alert-color .arrow.right,
.ids-popup.tooltip.alert-color .arrow.right::after, .ids-popup.tooltip.warning-color .arrow.right,
.ids-popup.tooltip.warning-color .arrow.right::after {
  border-right-color: var(--ids-tooltip-color-background-warning);
}
.ids-popup.tooltip.alert-color .arrow.top,
.ids-popup.tooltip.alert-color .arrow.top::after, .ids-popup.tooltip.warning-color .arrow.top,
.ids-popup.tooltip.warning-color .arrow.top::after {
  border-top-color: var(--ids-tooltip-color-background-warning);
}
.ids-popup.tooltip.success-color {
  background-color: var(--ids-tooltip-color-background-success);
}
.ids-popup.tooltip.success-color .arrow.bottom,
.ids-popup.tooltip.success-color .arrow.bottom::after {
  border-bottom-color: var(--ids-tooltip-color-background-success);
}
.ids-popup.tooltip.success-color .arrow.left,
.ids-popup.tooltip.success-color .arrow.left::after {
  border-left-color: var(--ids-tooltip-color-background-success);
}
.ids-popup.tooltip.success-color .arrow.right,
.ids-popup.tooltip.success-color .arrow.right::after {
  border-right-color: var(--ids-tooltip-color-background-success);
}
.ids-popup.tooltip.success-color .arrow.top,
.ids-popup.tooltip.success-color .arrow.top::after {
  border-top-color: var(--ids-tooltip-color-background-success);
}
.ids-popup.tooltip-alt {
  background-color: var(--ids-tooltip-color-background-inverse);
  padding: var(--ids-tooltip-padding);
  border-radius: var(--ids-tooltip-border-radius);
  font-size: var(--ids-tooltip-font-size);
  color: var(--ids-tooltip-color-text-inverse);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
}
.ids-popup.modal {
  background-color: var(--ids-modal-color-background);
  border: 1px solid transparent;
  padding: var(--ids-modal-padding);
  border-radius: var(--ids-modal-border-radius);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  color: var(--ids-modal-color-text);
}
.ids-popup.modal.open {
  border-color: var(--ids-modal-color-border);
  box-shadow: var(--ids-modal-shadow-default);
}
.ids-popup.dropdown {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--ids-dropdown-color-background-default);
  box-shadow: var(--ids-dropdown-shadow-default);
  border-radius: var(--ids-dropdown-border-radius);
  outline: none;
  border-top-color: var(--ids-dropdown-attached-color-border);
}
.ids-popup.dropdown.open {
  border: 1px solid var(--ids-dropdown-color-border);
  border-top-color: var(--ids-dropdown-attached-color-border);
}
.ids-popup.dropdown.flipped {
  border-radius: var(--ids-dropdown-border-radius-opened-up);
  border-bottom-color: var(--ids-dropdown-attached-color-border);
  border-top-color: var(--ids-dropdown-color-border);
  box-shadow: var(--ids-dropdown-shadow-opened-up);
}
.ids-popup.module-nav {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--ids-module-nav-input-bg-color);
  border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);
  border-radius: var(--ids-module-nav-common-border-radius);
  box-shadow: var(--ids-module-nav-settings-menu-box-shadow);
  color: var(--ids-module-nav-settings-menu-item-text-color);
  padding-block: var(--ids-module-nav-gutter-size);
}
.ids-popup:not(.position-viewport).has-maxheight .content-wrapper {
  height: var(--ids-popup-maxheight);
  overflow: auto;
}

.content-wrapper {
  overflow: hidden;
  position: static;
  height: 100%;
  width: 100%;
}

:host([dir=rtl]) .arrow.bottom::after {
  left: var(--ids-popup-arrow-size);
}
:host([dir=rtl]) .arrow.top::after {
  left: unset;
  right: calc(var(--ids-popup-arrow-size) * -1);
}
:host([dir=rtl]) .ids-popup.tooltip .arrow.top::after {
  left: calc(var(--ids-popup-arrow-size) * -1);
}`;var Dt=Rt(It(xt(Tt(kt)))),T,k,r,Nt,at,Lt,Mt,w,lt,M,R,I,y,v,pt,Y,dt,Ot,Ht,O,P,_,J,E,H,ct,ht,N,ut,A,C,z,Ct,zt,gt,Gt,ft,K,mt,bt,U=class extends Dt{constructor(){super();g(this,r);V(this,"shouldUpdate",!1);V(this,"scrollParentElem");V(this,"useRight",!1);g(this,T);g(this,k);g(this,w,null);g(this,M);g(this,R);g(this,I);g(this,y);g(this,v);g(this,O);g(this,P);g(this,_,x[0]);g(this,E);g(this,H);g(this,N);V(this,"open");g(this,A);g(this,C);g(this,z);l(this,M,it),l(this,R,G[0]),l(this,I,D[0]),l(this,y,$[0]),l(this,w,null),this.animated=!1,l(this,_,x[0]),l(this,E,null),l(this,O,!1),l(this,P,document.body),l(this,H,rt[1]),l(this,v,""),l(this,N,st[0]),l(this,A,!1),l(this,C,0),l(this,z,0),this.open=!1,this.shouldUpdate=!1}connectedCallback(){super.connectedCallback(),this.containingElem=W(this,"ids-container")||document.body,p(this,r,Lt).call(this),this.shouldUpdate=!0,p(this,r,Mt).call(this)}disconnectedCallback(){super.disconnectedCallback?.(),s(this,k)&&(s(this,k)?.disconnect(),l(this,k,void 0)),s(this,T)&&(s(this,T)?.disconnect(),l(this,T,void 0)),l(this,w,null),l(this,E,null),l(this,P,null),this.containingElem=null}static get attributes(){return[...super.attributes,...nt]}template(){return`<div class="ids-popup${this.animated?` animated animation-${this.animationStyle}`:""}" part="popup">
      <div class="arrow" part="arrow"></div>
      <div class="content-wrapper">
        <slot name="content"></slot>
      </div>
    </div>`}get innerRect(){return this.getBoundingClientRect()}get wrapper(){return this.shadowRoot?.querySelector(".content-wrapper")}set alignTarget(t){let o=typeof t=="string"&&t.length,i=t instanceof HTMLElement||t instanceof SVGElement;if(!o&&!i){s(this,w)!==null&&(l(this,w,null),this.removeAttribute(d.ALIGN_TARGET),p(this,r,lt).call(this));return}let e=null;if(o){if(e=Q(this).querySelector(t),!(e instanceof HTMLElement||e instanceof SVGElement))return;this.setAttribute(d.ALIGN_TARGET,t)}else i&&(e=t);e!==null&&(!s(this,w)||!s(this,w).isEqualNode(e))&&(l(this,w,e),p(this,r,lt).call(this))}get alignTarget(){return s(this,w)}set align(t){let o=s(this,M),i=t;(typeof i!="string"||!i.length)&&(i=it);let e=i.split(",");e=e.map(f=>f.trim().toLowerCase());let n=e[0];if($.includes(n)&&(l(this,y,n),e[0]=s(this,y)),e[1]||e.push("center"),et.includes(e[0])||St.includes(e[1])){let f=e[1];e[1]=e[0],e[0]=f}let a,c;G.includes(e[0])?(a=e[0],l(this,R,e[0])):a=this.alignX,D.includes(e[1])?(c=e[1],l(this,I,e[1])):c=this.alignY;let h=q(a,c,s(this,y));o!==h?(l(this,M,h),this.setAttribute(d.ALIGN,h),this.place()):this.hasAttribute("align")||this.setAttribute(d.ALIGN,o)}get align(){return s(this,M)}set alignX(t){if(typeof t!="string"||!t.length)return;let o=t;if(G.includes(t)||(o=G[0]),this.hasAttribute(d.ALIGN_X)&&this.removeAttribute(d.ALIGN_X),s(this,R)!==o){l(this,R,o);let i=s(this,I);this.align=q(o,i,o)}}get alignX(){return s(this,R)}set alignY(t){if(typeof t!="string"||!t.length)return;let o=D[0];if(D.includes(t)&&(o=t),this.hasAttribute(d.ALIGN_Y)&&this.removeAttribute(d.ALIGN_Y),s(this,I)!==o){l(this,I,o);let i=s(this,R);this.align=q(i,o,o)}}get alignY(){return s(this,I)}set alignEdge(t){if(typeof t!="string"||!t.length)return;let o;if($.includes(t)?o=t:o=$[0],this.hasAttribute(d.ALIGN_EDGE)&&this.removeAttribute(d.ALIGN_EDGE),s(this,y)!==o){let i=this.alignX,e=this.alignY;l(this,y,o),o==="center"?(i=o,e=o):et.includes(o)?e=o:i=o,this.align=q(i,e,o)}}get alignEdge(){return s(this,y)}get oppositeAlignEdge(){return p(this,r,Y).call(this,this.alignEdge)}get maxHeight(){return this.getAttribute(d.MAX_HEIGHT)}set maxHeight(t){let o=tt(t);o?(this.setAttribute(d.MAX_HEIGHT,o),p(this,r,pt).call(this,o)):this.removeAttribute(d.MAX_HEIGHT)}set animated(t){B(t)?this.setAttribute(d.ANIMATED,""):this.removeAttribute(d.ANIMATED),p(this,r,Ot).call(this)}get animated(){return B(this.getAttribute(d.ANIMATED))||!1}set animationStyle(t){F.includes(t)&&(p(this,r,Ht).call(this,t),this.setAttribute(d.ANIMATION_STYLE,t))}get animationStyle(){let t=this.getAttribute(d.ANIMATION_STYLE);return t&&F.includes(t)?t:F[0]}set offsetContainer(t){t?this.setAttribute(d.OFFSET_CONTAINER,t):this.removeAttribute(d.OFFSET_CONTAINER)}get offsetContainer(){return this.getAttribute(d.OFFSET_CONTAINER)}set bleed(t){let o=B(t);s(this,O)!==o&&(l(this,O,o),o?this.setAttribute(d.BLEED,""):this.removeAttribute(d.BLEED),this.place())}get bleed(){return s(this,O)}set containingElem(t){(t instanceof HTMLElement||t instanceof SVGElement)&&s(this,P)!==t&&(l(this,P,t),this.place())}get containingElem(){return s(this,P)}set arrow(t){let o=s(this,_),i=x[0];t&&x.includes(t)&&(i=t),i!==o&&(l(this,_,i),i!==x[0]?this.setAttribute(d.ARROW,`${i}`):this.removeAttribute(d.ARROW),p(this,r,J).call(this,o,i))}get arrow(){let t=this.getAttribute(d.ARROW);return t||x[0]}get arrowEl(){return this.container?.querySelector(".arrow")}set arrowTarget(t){let o=typeof t=="string"&&t.length,i=t instanceof HTMLElement||t instanceof SVGElement;if(!o&&!i){s(this,E)!==null&&(l(this,E,null),this.removeAttribute(d.ARROW_TARGET));return}let e=null;if(o){if(e=Q(this).querySelector(t),!(e instanceof HTMLElement||e instanceof SVGElement))return;this.setAttribute(d.ARROW_TARGET,t)}else i&&(e=t);e!==null&&(!s(this,E)||!s(this,E).isEqualNode(e))&&(l(this,E,e),p(this,r,J).call(this,"",this.arrow))}get arrowTarget(){return s(this,E)||this.alignTarget}set positionStyle(t){let o=s(this,H);rt.includes(t)&&(this.setAttribute(d.POSITION_STYLE,t),l(this,H,t),t!==o?p(this,r,ct).call(this,o,t):p(this,r,ct).call(this,"",o),this.place())}get positionStyle(){return s(this,H)}set type(t){let o=s(this,N);t&&o!==t&&st.includes(t)?(l(this,N,t),this.setAttribute(d.TYPE,s(this,N)),p(this,r,ut).call(this,o,t),this.place()):p(this,r,ut).call(this,"",o)}get type(){return s(this,N)}set visible(t){let o=B(t);s(this,A)!==o&&(l(this,A,o),o?(this.setAttribute(d.VISIBLE,""),this.addOpenEvents()):(this.removeAttribute(d.VISIBLE),this.removeOpenEvents()),this.refreshVisibility())}get visible(){return s(this,A)}async refreshVisibility(){if(!this.container)return;let t=this.container.classList;s(this,A)&&!t.contains("open")&&await this.show(),!s(this,A)&&!this.hasAttribute("aria-hidden")&&await this.hide()}set x(t){let o=parseInt(t?.toString(),10);Number.isNaN(o)&&(o=0),o!==s(this,C)&&(l(this,C,o),this.setAttribute(d.X,o.toString()))}get x(){return s(this,C)}set y(t){let o=parseInt(t?.toString(),10);Number.isNaN(o)&&(o=0),o!==s(this,z)&&(l(this,z,o),this.setAttribute(d.Y,o.toString()))}get y(){return s(this,z)}setPosition(t=null,o=null,i=null,e=null){let n=this;Number.isNaN(t)||(n.x=t),Number.isNaN(o)||(n.y=o),i&&(this.visible=!0),e&&this.place()}async show(){!this.visible||!this.container||(this.place(),this.placeArrow(s(this,v)),this.removeAttribute("aria-hidden"),p(this,r,ht).call(this),this.container.classList.add("open"),this.open=!0,this.triggerEvent("show",this,{bubbles:!0,detail:{elem:this}}),this.animated&&await Z(this.container,"opacity"),this.correct3dMatrix(),this.addOpenEvents())}async hide(){!this.visible&&!this.open||(this.setAttribute("aria-hidden","true"),this.visible=!1,this.open=!1,p(this,r,K).call(this),this.container.classList.remove("open"),this.triggerEvent("hide",this,{bubbles:!0,detail:{elem:this}}),this.animated&&await Z(this.container,"opacity"),this.removeOpenEvents())}onOutsideClick(t){!t?.target||this.contains(t.target)||this.hide()}place(){if(this.visible&&this.positionStyle!=="viewport"){p(this,r,pt).call(this);let{alignTarget:t}=this;t?p(this,r,zt).call(this):p(this,r,Ct).call(this)}}onPlace(t,o){return t}onXYSwitch(t){return t}correct3dMatrix(){if(!this.container||this.positionStyle!=="viewport")return;p(this,r,K).call(this);let t=window.getComputedStyle(this.container,null),o=t.getPropertyValue("-webkit-transform")||t.getPropertyValue("-moz-transform")||t.getPropertyValue("transform")||!1;if(!o)return;let i=o.replace(/ |\(|\)|matrix3d/g,"").split(",");for(let e=0;e<i.length;e++)e===0&&i[e]<1&&(i[e]=1),e>0&&(i[e]>4||i[e]<-4)&&(i[e]=Math.ceil(i[e])),e===i.length-1&&i[e]>1&&(i[e]=1);this.container.style.transform=`matrix3d(${i.join()})`}placeArrow(t){let o=t||this.arrow,i=this.arrowEl,e=this.alignTarget,n=this.arrowTarget;if(o==="none"||!e||!n||!i){i&&(i.hidden=!0);return}i.removeAttribute("hidden"),i.style.marginLeft="",i.style.marginTop="";let a=i.getBoundingClientRect(),c=e.getBoundingClientRect(),h=n.getBoundingClientRect(),u={},f=o==="right"||o==="left"?"marginTop":"marginLeft",m=!1,S=0,X=0,b;(o==="left"||o==="right")&&(S=h.top+h.height/2,X=a.top+a.height/2,b=S-X,u.top=a.top+b,u.bottom=a.bottom+b,(u.top<=c.top||u.bottom>=c.bottom)&&(m=!0)),(o==="top"||o==="bottom")&&(S=h.left+h.width/2,X=a.left+a.width/2,b=S-X,u.left=a.left+b,u.right=a.right+b,(u.left<=c.left||u.right>=c.right)&&(m=!0)),b=Math.ceil(b),m&&(i.hidden=!0),i.style[f]=`${b}px`}set height(t){let o=ot(t);this.height!==o&&(o.length?(this.container?.style.setProperty("height",o),this.setAttribute(d.HEIGHT,o)):(this.container?.style.removeProperty("height"),this.removeAttribute(d.HEIGHT)))}get height(){return this.container?.style.height||""}set width(t){let o=ot(t);this.width!==o&&(o.length?(this.container?.style.setProperty("width",o),this.setAttribute(d.WIDTH,o)):(this.container?.style.removeProperty("width"),this.removeAttribute(d.WIDTH)))}get width(){return this.container?.style.width??""}};T=new WeakMap,k=new WeakMap,r=new WeakSet,Nt=function(){p(this,r,K).call(this),this.place(),p(this,r,at).call(this)},at=function(){this.style.transition="none",this.container?.style.setProperty("transition","none"),this.correct3dMatrix(),this.style.transition="",this.container?.style.setProperty("transition","")},Lt=function(){l(this,T,new MutationObserver(t=>{if(s(this,A)){let o=!1;for(let i of t){if(o)break;["subtree","childList","characterData","characterDataOldValue"].includes(i.type)&&(this.place(),o=!0)}}})),l(this,k,new ResizeObserver(t=>{if(this.open){for(let o of t)o.target.tagName.toLowerCase()==="ids-container"?p(this,r,Nt).call(this):p(this,r,at).call(this);p(this,r,ht).call(this)}})),nt.forEach(t=>{let o=Et(t);this[o]=this.getAttribute(t)||this[o]})},Mt=function(){let t=W(this,"ids-container");s(this,k)?.observe(this),t&&s(this,k)?.observe(t),this.onLocaleChange=()=>{this.localeAPI.isRTL()?this.setAttribute("dir","rtl"):this.removeAttribute("dir")}},w=new WeakMap,lt=function(){s(this,w)?s(this,T)?.observe(s(this,w),{attributes:!0,attributeFilter:["style","height","width"],attributeOldValue:!0,characterData:!0,characterDataOldValue:!0,childList:!0,subtree:!0}):s(this,T)?.disconnect(),this.place()},M=new WeakMap,R=new WeakMap,I=new WeakMap,y=new WeakMap,v=new WeakMap,pt=function(t){if(this.positionStyle==="viewport"){this.wrapper?.setAttribute(d.TABINDEX,"0"),this.container?.style.setProperty(j,"auto");return}let o=this.containingElem,i=document.body.offsetHeight,e=tt(t||this.maxHeight);if(o?i=o.offsetHeight:window&&(i=window.innerHeight,e=`${i}px`),e)i<parseInt(e)&&(e=`${i}px`);else{let n=parseInt(window.getComputedStyle(this.wrapper).height);i<=n&&(e=`${i}px`)}this.container&&(this.wrapper&&this.wrapper.setAttribute(d.TABINDEX,"0"),e?(this.container.style.setProperty(j,`${e}`),this.container.classList.add("has-maxheight")):(this.container.classList.remove("has-maxheight"),this.container.style.removeProperty(j)))},Y=function(t){return{left:"right",right:"left",top:"bottom",bottom:"top"}[t??""]||"none"},dt=function(t){switch(t){case"top":case"bottom":return"right";case"left":case"right":return"bottom";default:return"none"}},Ot=function(){this.container?.classList[this.animated?"add":"remove"]("animated")},Ht=function(t){if(!this.container)return;let o=this.container.classList,i=F.map(e=>`animation-${e}`);o.remove(...i),o.add(`animation-${t}`)},O=new WeakMap,P=new WeakMap,_=new WeakMap,J=function(t,o){if(!this.container)return;let i=this.arrowEl,e=this.arrowEl?.classList,n=o==="none";o=o==="center"?"bottom":o,i&&(i.hidden=n);let a="arrow";t===""?e?.remove(...x):t&&e?.remove(t),o&&!n&&(e?.add(o),a+=`-${o}`),i?.setAttribute("part",a)},E=new WeakMap,H=new WeakMap,ct=function(t,o){if(!this.container)return;let i=this.container.classList;t&&i.remove(`position-${t}`),i.add(`position-${o}`)},ht=function(){if(!this.container||!this.wrapper)return;let t=this.container.classList;t.remove("fit-viewport");let o=this.wrapper.getBoundingClientRect().height,i=this.container.getBoundingClientRect().height;o>i&&t.add("fit-viewport")},N=new WeakMap,ut=function(t,o){if(!this.container)return;let i=this.container.classList;t&&i.remove(t),i.add(o)},A=new WeakMap,C=new WeakMap,z=new WeakMap,Ct=function(){let t=this.getBoundingClientRect(),o=this.x,i=this.y;switch(this.alignX){case"right":o-=t.width;break;case"center":o-=t.width/2;break;default:break}switch(this.alignY){case"bottom":i-=t.height;break;case"center":i-=t.height/2;break;default:break}t.x=o,t.y=i,t=p(this,r,gt).call(this,t),t=p(this,r,mt).call(this,this.parentNode,t,this.scrollParentElem),typeof this.onPlace=="function"&&(t=this.onPlace(t,this)),t=p(this,r,bt).call(this,t),p(this,r,ft).call(this,t)},zt=function(){if(!this.alignTarget)return;let t=this.getBoundingClientRect();l(this,v,p(this,r,Gt).call(this,t));let o=p(this,r,Y).call(this,this.alignEdge),i=this.alignEdge!==s(this,v)&&p(this,r,Y).call(this,this.alignEdge)!==s(this,v),e={flip:this.alignEdge!==s(this,v)&&!i,oppositeEdge:o,shouldSwitchXY:i,targetEdge:s(this,y),x:i?this.y:this.x,y:i?this.x:this.y};typeof this.onXYSwitch=="function"&&(e=this.onXYSwitch(e));let n=e.x,a=e.y,c=this.alignTarget.getBoundingClientRect(),h=s(this,v)||this.alignEdge,u=!1,f=!1;if(this.container?.classList.toggle("flipped",this.alignEdge!==s(this,v)&&!i),D.includes(h)){switch(h){case"top":a=c.top-t.height-a;break;case"bottom":a=c.bottom+a;break;default:a=c.top+c.height/2-t.height/2+a,f=!0}switch(this.alignX){case"left":n=c.left+n;break;case"right":n=c.right-t.width-n;break;default:n=c.left+c.width/2-t.width/2+n,u=!0}}if(G.includes(h)){switch(h){case"left":n=c.left-t.width-n;break;case"right":n=c.right+n;break;default:if(u)break;n=c.left+c.width/2-t.width/2+n}switch(this.alignY){case"top":a=c.top+a;break;case"bottom":a=c.bottom-t.height+a;break;default:if(f)break;a=c.top+c.height/2-t.height/2+a}}if(h==="none"){let m=this.containingElem?.clientWidth,S=this.containingElem?.clientHeight;m&&S&&(n=(m-t.width)/2,a=(S-t.height)/2)}t.x=n,t.y=a,t=p(this,r,gt).call(this,t),t=p(this,r,mt).call(this,this.parentNode,t,this.scrollParentElem),typeof this.onPlace=="function"&&(t=this.onPlace(t,this)),t=p(this,r,bt).call(this,t),p(this,r,ft).call(this,t),this.arrow&&this.arrow!==x[0]&&(p(this,r,J).call(this,"",s(this,v)),this.placeArrow(s(this,v)))},gt=function(t){if(this.bleed||!this.containingElem)return t;let o=window.innerWidth,i=window.innerHeight,e=this.containingElem.getBoundingClientRect(),n=this.bleed,a=t.x,c=t.y,h=n?o:e.right,u=n?0:e.left,f=n?0:e.top,m=n?i:e.bottom;return t.right>h&&(a-=t.right-h),t.left<u&&(a+=Math.abs(t.left)+u),t.bottom>m&&(c-=t.bottom-m),t.top<f&&(c+=Math.abs(t.top)+f),c<0&&(c=0),t.x=a,t.y=c,t},Gt=function(t){if(!this.containingElem||!this.alignTarget)return"none";let o=window.innerWidth,i=window.innerHeight,e=this.containingElem.scrollLeft||0,n=this.containingElem.scrollTop||0,a=this.bleed,c=this.containingElem.getBoundingClientRect(),h=this.alignTarget.getBoundingClientRect(),u=b=>{let L=0;switch(b){case"left":L=(a?0:c.left)-e-h.left+this.x;break;case"right":L=(a?o:c.right)-e-h.right-this.x;break;case"top":L=(a?0:c.top)-n-h.top+this.y;break;case"bottom":default:L=(a?i:c.bottom)-n-h.bottom-this.y;break}return Math.abs(L)},f=this.alignEdge,m=["top","bottom"].includes(f)?"height":"width";return[this.alignEdge,p(this,r,Y).call(this,this.alignEdge),p(this,r,dt).call(this,this.alignEdge),p(this,r,Y).call(this,p(this,r,dt).call(this,this.alignEdge))].find(b=>{let L=u(b);return t[m]<=L})||"right"},ft=function(t){this.style.removeProperty("left"),this.style.removeProperty("right"),this.style.removeProperty("top");let o="left";if(this.useRight&&(o="right"),this.offsetContainer){let i=W(this,this.offsetContainer),e=0;if((i?.nodeName==="IDS-MODAL"||i?.nodeName==="IDS-ACTION-PANEL")&&(i=i.shadowRoot.querySelector("ids-popup")?.container,e=W(this,"ids-data-grid")?60:0),i){let n=i.getBoundingClientRect();t.x-=n.left,t.y-=n.top+e}}this.style.setProperty(o,`${t.x}px`),this.style.setProperty("top",`${t.y}px`)},K=function(){this.container?.style.removeProperty("transform")},mt=function(t,o,i){let e=At(o||t.getBoundingClientRect()),n=!1,a=!1,c=h=>{let u,f;if(h&&!n){if(h.toString()==="[object ShadowRoot]"&&(h=h.host),h instanceof HTMLElement||h instanceof SVGElement){u=getComputedStyle(h),f=h.getBoundingClientRect();let m=i||h;a||(m.scrollLeft!==0&&(e.x-=m.scrollLeft,a=!0),m.scrollTop!==0&&(e.y-=m.scrollTop,a=!0)),u.position==="relative"&&this.positionStyle!=="fixed"&&(e.x-=f.x,e.y-=f.y,n=!0)}h.parentNode&&c(h.parentNode)}};return c(t),e},bt=function(t){return this.useRight&&this.localeAPI.isRTL()&&(t.x=window.innerWidth-t.x-t.width),t},U=wt([vt("ids-popup"),yt(Pt)],U);export{U as a};
